import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  MultiEmailPicker,
  MultiEmailPickerSchema,
  MultiEmailPickerValidation,
} from './MultiEmailPicker';

export const MultiEmailPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'MultiEmailPicker',
    component: MultiEmailPicker,
    schema: MultiEmailPickerSchema,
    validation: MultiEmailPickerValidation,
  }),
);
